import { useBlurbContext } from '../context/Blurb.context';
import { RegisteredModalContext } from '../context/RegisteredModal.context';
import { Outlet } from 'react-router-dom';

export const BlurbLayout = () => {
  const { settings } = useBlurbContext();
  return settings ? (
    <RegisteredModalContext>
      <Outlet />
    </RegisteredModalContext>
  ) : null;
};
